export default __webpack_public_path__ + "static/media/serum.c01a4750.png";